import { clsx } from 'clsx';
import React from 'react';
import { HStack } from '~/components/layout/Stack';
import IconCheckRoundFill from '~/icons/icon-check-round-fill.svg?react';
import styles from './AddCompanyStepper.module.scss';

const steps = ['search', 'company-data', 'complete'] as const;
export type AddCompanySteps = (typeof steps)[number];

interface Props {
  activeStep: AddCompanySteps;
}

const AddCompanyStepper = ({ activeStep }: Props) => {
  const activeIndex = steps.findIndex((el) => el === activeStep);

  return (
    <HStack align="center" className={styles.container}>
      {steps.map((step, index) => {
        const active = index <= activeIndex;
        return (
          <React.Fragment key={step}>
            <IconCheckRoundFill className={clsx(styles.indicator, { [styles.active!]: active })} />
            <div className={clsx(styles.separator, { [styles.active!]: active })} />
          </React.Fragment>
        );
      })}
    </HStack>
  );
};

export default AddCompanyStepper;
